// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dot {
   height: 25px;
   width: 25px;
   border-radius: 50%;
   display: inline-block;
}

.signer-selected {
   width: 180px;
   margin-left: 30px;
   margin-top: 5px
}

.signer-list {
   margin-left: 30px;
   margin-top: -10px;
}

::ng-deep .mat-expansion-panel-header {
   display: flex;
   flex-direction: row;
   align-items: center;
   padding: 0 24px;
   border-radius: inherit;
   padding-bottom: 15px;
}

::ng-deep mat-expansion-panel-header {
   height: 60px !important;
}

::ng-deep .mat-list-item-content {
   padding: 0 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/tools/tools.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,WAAW;GACX,kBAAkB;GAClB,qBAAqB;AACxB;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB;AACH;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,mBAAmB;GACnB,eAAe;GACf,sBAAsB;GACtB,oBAAoB;AACvB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,0BAA0B;AAC7B","sourcesContent":[".dot {\n   height: 25px;\n   width: 25px;\n   border-radius: 50%;\n   display: inline-block;\n}\n\n.signer-selected {\n   width: 180px;\n   margin-left: 30px;\n   margin-top: 5px\n}\n\n.signer-list {\n   margin-left: 30px;\n   margin-top: -10px;\n}\n\n::ng-deep .mat-expansion-panel-header {\n   display: flex;\n   flex-direction: row;\n   align-items: center;\n   padding: 0 24px;\n   border-radius: inherit;\n   padding-bottom: 15px;\n}\n\n::ng-deep mat-expansion-panel-header {\n   height: 60px !important;\n}\n\n::ng-deep .mat-list-item-content {\n   padding: 0 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
